import React, { useEffect, useState } from 'react';
import api from '../api';
import { PageHeader, Modal, Badge, Avatar, EmptyState, useToast, Confirm } from '../ui';
import { useLang } from '../Layout';
import { FaPlus, FaTrash, FaUserCheck, FaPen } from 'react-icons/fa6';

const T = {
  bn: {
    title: 'কর্মীরা', sub: 'জন কর্মী', new: 'নতুন কর্মী', all: 'সব', name: 'নাম', contractor: 'কন্ট্রাক্টর',
    phone: 'ফোন', rate: 'দিন প্রতি হার', active: 'সক্রিয়', inactive: 'বন্ধ', save: 'সংরক্ষণ করুন',
    createLogin: 'ফোন দিয়ে লগইন অ্যাকাউন্ট', password: 'পাসওয়ার্ড', empty: 'কোনো কর্মী নেই।',
    delTitle: 'কর্মী মুছুন?', delMsg: 'কে মুছে ফেলা হবে।', select: '— নির্বাচন করুন —',
    added: 'কর্মী যোগ হয়েছে', edited: 'কর্মী আপডেট হয়েছে', edit: 'এডিট', status: 'স্ট্যাটাস',
  },
  en: {
    title: 'Workers', sub: 'workers', new: 'Add Worker', all: 'All', name: 'Name', contractor: 'Contractor',
    phone: 'Phone', rate: 'Rate per day', active: 'Active', inactive: 'Inactive', save: 'Save',
    createLogin: 'Create phone login', password: 'Password', empty: 'No workers yet.',
    delTitle: 'Delete Worker?', delMsg: 'will be deleted.', select: '— Select —', added: 'Worker added',
    edited: 'Worker updated', edit: 'Edit', status: 'Status',
  },
};

export default function Workers({ role }) {
  const { lang } = useLang(); const t = T[lang];
  const isOwner = role === 'owner';
  const base = role === 'manager' ? '/manager' : '/owner';
  const { toast } = useToast();
  const [list, setList] = useState([]);
  const [contractors, setContractors] = useState([]);
  const [filter, setFilter] = useState('');
  const [show, setShow] = useState(false);
  const [editing, setEditing] = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);
  const [form, setForm] = useState({ name: '', contractor_id: '', phone: '', rate_per_day: '', create_login: false, password: '123456', is_active: true });
  const [err, setErr] = useState('');

  const load = () => { const q = filter ? `?contractor_id=${filter}` : ''; api.get(`${base}/workers${q}`).then(({ data }) => setList(data.workers)).catch(() => {}); };
  useEffect(() => { load(); }, [filter]);
  useEffect(() => { api.get(`${base}/contractors`).then(({ data }) => setContractors(data.contractors)).catch(() => {}); }, []);

  async function save(e) {
    e.preventDefault(); setErr('');
    try {
      if (editing) {
        const { create_login, password, ...rest } = form;
        await api.put(`${base}/workers/${editing.id}`, rest);
        toast(t.edited, 'success');
      } else {
        await api.post(`${base}/workers`, form);
        toast(t.added, 'success');
      }
      setShow(false); setEditing(null); setForm({ name: '', contractor_id: '', phone: '', rate_per_day: '', create_login: false, password: '123456', is_active: true }); load();
    }
    catch (e) { setErr(e.response?.data?.message || 'সমস্যা হয়েছে'); }
  }
  async function del(id) { await api.delete(`${base}/workers/${id}`); load(); }

  function openEdit(w) {
    setEditing(w);
    setForm({ name: w.name, contractor_id: String(w.contractor_id ?? ''), phone: w.phone || '', rate_per_day: String(w.rate_per_day ?? ''), create_login: false, password: '123456', is_active: !!w.is_active });
    setShow(true); setErr('');
  }

  return (
    <div className="space-y-4">
      <PageHeader title={t.title} subtitle={`${list.length} ${t.sub}`}
        actions={<button className="btn-primary text-sm" onClick={() => { setShow(true); setErr(''); }}><FaPlus /> {t.new}</button>} />

      {/* Filter pills */}
      <div className="flex gap-2 overflow-x-auto pb-1">
        <button onClick={() => setFilter('')}
          className={`btn text-xs whitespace-nowrap ${filter === '' ? 'bg-ink-900 text-white' : 'bg-white text-ink-500 border border-ink-200'}`}>{t.all}</button>
        {contractors.map((c) => (
          <button key={c.id} onClick={() => setFilter(String(c.id))}
            className={`btn text-xs whitespace-nowrap ${filter === String(c.id) ? 'bg-brand-500 text-white' : 'bg-white text-ink-500 border border-ink-200'}`}>{c.name}</button>
        ))}
      </div>

      <div className="bg-white rounded-xl border border-ink-100 shadow-soft overflow-hidden">
        <div className="hidden sm:block overflow-x-auto">
          <table className="charm-table">
            <thead><tr><th>{t.name}</th><th>{t.contractor}</th><th>{t.phone}</th><th>{t.rate}</th><th>Status</th><th /></tr></thead>
            <tbody>
              {list.map((w) => (
                <tr key={w.id}>
                  <td><div className="flex items-center gap-3"><Avatar name={w.name} className="w-8 h-8 text-xs" /><span className="font-medium text-ink-800">{w.name}</span></div></td>
                  <td className="text-ink-500">{w.contractor_name || '—'}</td>
                  <td className="text-ink-500">{w.phone || '—'}</td>
                  <td className="font-medium">৳{w.rate_per_day}</td>
                  <td><Badge color={w.is_active ? 'active' : 'paused'}>{w.is_active ? t.active : t.inactive}</Badge></td>
                  <td>
                    <div className="flex items-center gap-1">
                      <button onClick={() => openEdit(w)} title={t.edit} className="p-1.5 text-ink-300 hover:text-brand-600 hover:bg-brand-50 rounded-lg transition"><FaPen size={13} /></button>
                      {isOwner && <button onClick={() => setConfirmDel(w)} className="p-1.5 text-ink-300 hover:text-rose-600 hover:bg-rose-50 rounded-lg transition"><FaTrash size={13} /></button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile card list */}
        <div className="sm:hidden divide-y divide-ink-50">
          {list.map((w) => (
            <div key={w.id} className="px-4 py-3 flex items-center gap-3">
              <Avatar name={w.name} className="w-10 h-10" />
              <div className="flex-1 min-w-0">
                <div className="font-medium text-ink-800 truncate">{w.name}</div>
                <div className="text-xs text-ink-400 truncate">{w.contractor_name || '—'} • ৳{w.rate_per_day}</div>
              </div>
              <Badge color={w.is_active ? 'active' : 'paused'}>{w.is_active ? t.active : t.inactive}</Badge>
              <div className="flex items-center gap-1">
                <button onClick={() => openEdit(w)} className="p-2 text-ink-300 hover:text-brand-600"><FaPen size={13} /></button>
                {isOwner && <button onClick={() => setConfirmDel(w)} className="p-2 text-ink-300 hover:text-rose-600"><FaTrash size={13} /></button>}
              </div>
            </div>
          ))}
        </div>
        {list.length === 0 && <EmptyState icon="🧑‍🔧" title={t.empty} />}
      </div>

      <Modal open={show} onClose={() => { setShow(false); setEditing(null); }} title={editing ? t.edit : t.new}>
        <form onSubmit={save} className="space-y-3.5">
          {err && <div className="text-sm bg-rose-50 text-rose-600 px-3 py-2 rounded-xl">⚠️ {err}</div>}
          <div><label className="label">{t.contractor} <span className="text-rose-500">*</span></label>
            <select className="input" value={form.contractor_id} onChange={(e) => setForm({ ...form, contractor_id: e.target.value })} required><option value="">{t.select}</option>{contractors.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div>
          <div><label className="label">{t.name} <span className="text-rose-500">*</span></label><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="label">{t.phone}</label><input className="input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} inputMode="tel" /></div>
            <div><label className="label">{t.rate} (৳)</label><input className="input" type="number" value={form.rate_per_day} onChange={(e) => setForm({ ...form, rate_per_day: e.target.value })} /></div>
          </div>
          {editing && (
            <div><label className="label">{t.status}</label>
              <select className="input" value={form.is_active ? '1' : '0'} onChange={(e) => setForm({ ...form, is_active: e.target.value === '1' })}>
                <option value="1">{t.active}</option>
                <option value="0">{t.inactive}</option>
              </select></div>
          )}
          {!editing && <label className="flex items-center gap-2.5 text-sm text-ink-700 bg-ink-50 border border-ink-100 rounded-xl px-3.5 py-3 cursor-pointer">
            <input type="checkbox" checked={form.create_login} onChange={(e) => setForm({ ...form, create_login: e.target.checked })} className="accent-brand-500 w-4 h-4" />
            <FaUserCheck className="text-brand-500" /> {t.createLogin}
          </label>}
          {!editing && form.create_login && <div><label className="label">{t.password}</label><input className="input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></div>}
          <button className="btn-primary w-full py-3">{t.save}</button>
        </form>
      </Modal>

      {confirmDel && (
        <Confirm open onClose={() => setConfirmDel(null)} onConfirm={() => del(confirmDel.id)}
          title={t.delTitle} message={`"${confirmDel.name}" ${t.delMsg}`} />
      )}
    </div>
  );
}